import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { User } from '../../typings/user';
import { BetaMark } from '../BetaMark/BetaMark';
import { UserLogin } from '../UserLogin/UserLogin';

import './CurrentUserBlockBody.css';

export interface CurrentUserBlockBodyProps {
    title: string;
    user: User;
    fixed?: boolean;
    isBeta?: boolean;
}

const bemCls = Bem.cls.bind(null, 'current-user-block-body');

export class CurrentUserBlockBody extends React.PureComponent<CurrentUserBlockBodyProps> {
    render() {
        const {
            title,
            user: { phone, login, name },
            fixed = false,
            isBeta
        } = this.props;

        return (
            <div className={bemCls()}>
                <div
                    className={bemCls('element', {
                        type: 'heading',
                        fixed
                    })}
                >
                    <span className={bemCls('heading-text')}>{title}</span>
                </div>

                {isBeta ? <BetaMark /> : null}

                {this.renderAvatar()}

                <div
                    className={bemCls('element', {
                        type: 'name',
                        fixed
                    })}
                    title={name}
                >
                    {name}
                </div>
                <div
                    className={bemCls('element', {
                        type: 'login',
                        fixed
                    })}
                    title={login}
                >
                    <UserLogin login={login} />
                </div>
                <div
                    className={bemCls('element', {
                        type: 'phone',
                        fixed
                    })}
                    title={phone}
                >
                    {phone}
                </div>
            </div>
        );
    }

    private renderAvatar(): React.ReactNode {
        const {
            user: { avatarLink }
        } = this.props;

        if (!avatarLink) {
            return null;
        }

        return (
            <div
                className={bemCls('element', {
                    type: 'avatar'
                })}
                style={{
                    background: `url(${avatarLink}) center / 180%`
                }}
            />
        );
    }
}
